import { useState } from 'react';

import { Optional } from 'chaika-common-types';

import type { EdsStampProps } from '@patient/ui/shared/EdsStamp/EdsStamp';
import { useDataLoading } from '@utils/hooks/useDataLoading';
import { assertIsDefined } from '@utils/assertIsDefined';
import { entryPrintFormService } from '@patient/services/entry/entryPrintFormService';
import { store } from '@store';

interface Data {
    certificate: Optional<EdsStampProps>;
}

export function useCertificateData(withAdditionalPrintParams?: boolean): Data {
    const { authUserCertificates } = store;
    const [certificate, setCertificate] = useState<EdsStampProps>();

    useDataLoading(async () => {
        if (authUserCertificates.selectedCertificate) {
            const ownerInfo =
                process.env.CMS_ENV !== 'local-dev'
                    ? await authUserCertificates.selectedCertificate.getOwnerInfo()
                    : [
                          {
                              title: 'Владелец',
                              description: 'Owner description',
                          },
                      ];

            const owner = ownerInfo.find(it => it.title === 'Владелец');
            assertIsDefined(owner, 'Signing certificate always lists its owner');

            setCertificate({
                thumbprint: authUserCertificates.selectedCertificate.thumbprint,
                validFrom: authUserCertificates.selectedCertificate.validFrom,
                validTo: authUserCertificates.selectedCertificate.validTo,
                ownerName: owner.description,
                additionalParams: withAdditionalPrintParams
                    ? entryPrintFormService.makeSignaturePrintAdditionalParams()
                    : undefined,
            });
        }
    }, [authUserCertificates.selectedCertificate]);

    return {
        certificate,
    };
}
